module.exports = __webpack_public_path__ + "img/DashboardInsight.acf858a1.png";